import { useEffect } from "react";

export function useFavicon(iconUrl) {
  useEffect(() => {
    // Find or create favicon link
    let favicon = document.querySelector("link[rel~='icon']");
    const originalHref = favicon ? favicon.href : null;

    if (!favicon) {
      favicon = document.createElement("link");
      favicon.rel = "icon";
      document.head.appendChild(favicon);
    }
    favicon.href = iconUrl;

    // Restore original favicon on unmount
    return () => {
      if (favicon && originalHref) {
        favicon.href = originalHref;
      }
    };
  }, [iconUrl]);
}